import React from 'react';
import { motion } from 'framer-motion';
import './Projects.css';

const projects = [
  { id: 1, title: 'College App', description: 'A app that tracks students day to day activities and auto attendance featuer on top' },
  { id: 2, title: 'Medicinal Mad Honey', description: 'A brand that sells mad honey in international market', link: 'https://medicinalmadhoney.com' },
  { id: 3, title: 'Everest Shilajit', description: 'A brand that sells Shilajit from himalayas in international market', link: 'https://everestshilajit.com/' },
  // { id: 4, title: '', description: '', link: '' },
];

const Projects = () => {
  return (
    <motion.section
      id="projects"
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 1 }}
      className="projects"
    >
      <h2>My Projects</h2>
      <div className="project-list">
        {projects.map((project) => (
          <motion.div
            key={project.id}
            initial={{ opacity: 0, x: -100 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5, delay: project.id * 0.2 }}
            className="project-card"
          >
            <a href={project.link} target="_blank" rel="noopener noreferrer" className="project-link">
              <h3>{project.title}</h3>
            </a>
            <p>{project.description}</p>
          </motion.div>
        ))}
      </div>
    </motion.section>
  );
};

export default Projects;